import * as React from 'react';
type Props = {
  className?: string;
};
export function Feeds2({ className }: Props) {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      data-testid="illustrated-Feeds 2"
      className={className}
    >
      <title>Feeds 2</title>
      <g
        id="Feeds-2"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Group-15"
          transform="translate(0.300000, 7.000000)"
          stroke="currentColor"
        >
          <path
            d="M6.41025,7.239078 C7.025865,8.228913 8.11272,8.819118 9.25617,8.777538 C10.837365,8.720943 11.705925,7.486248 11.79486,7.354578 M27.6325665,5.6630805 C27.6325665,8.5829205 25.2648165,10.9506705 22.3449765,10.9506705 C19.4239815,10.9506705 17.0573865,8.5829205 17.0573865,5.6630805 C17.0573865,2.7432405 19.4239815,0.3754905 22.3449765,0.3754905 C25.2648165,0.3754905 27.6325665,2.7432405 27.6325665,5.6630805 Z M14.390145,5.6630805 C14.390145,2.7432405 12.022395,0.3754905 9.102555,0.3754905 C6.18156,0.3754905 3.814965,2.7432405 3.814965,5.6630805 C3.814965,8.5840755 6.18156,10.9506705 9.102555,10.9506705 C12.022395,10.9506705 14.390145,8.5840755 14.390145,5.6630805 Z M22.344861,10.950786 C19.691826,10.950786 17.320611,11.970651 15.723246,13.576101 C14.125881,11.970651 11.754666,10.950786 9.102786,10.950786 C4.418106,10.950786 0.607761,14.125881 0.396396,18.107166 L13.638471,18.107166 L17.809176,18.107166 L31.051251,18.107166 C30.839886,14.125881 27.028386,10.950786 22.344861,10.950786 Z M19.6526715,7.3066455 C20.2682865,8.2964805 21.3551415,8.8866855 22.4985915,8.8451055 C24.0797865,8.7885105 24.9483465,7.5538155 25.0372815,7.4221455 M14.390145,5.6630805 C14.390145,8.5829205 12.022395,10.9506705 9.102555,10.9506705 C6.18156,10.9506705 3.814965,8.5829205 3.814965,5.6630805 C3.814965,2.7432405 6.18156,0.3754905 9.102555,0.3754905 C12.022395,0.3754905 14.390145,2.7432405 14.390145,5.6630805 Z M17.808945,18.1072815 C17.59758,14.1259965 13.78608,10.9509015 9.102555,10.9509015 C4.41903,10.9509015 0.60753,14.1259965 0.396165,18.1072815 L17.808945,18.1072815 Z"
            id="Combined-Shape"
          />
        </g>
      </g>
    </svg>
  );
}
